import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useState } from 'react';

import { setSessionStorage } from 'lib/sessionStorage';

import SESSION_STORAGE from 'constants/sessionStorage';

const UTM_PARAMS_TO_BE_SAVED_IN_SESSION_STORAGE = [
  'utm_campaign',
  'utm_content',
  'utm_medium',
  'utm_source',
];

const UtmContext = createContext({ isUtmLoaded: false });

const UtmProvider = ({ children }) => {
  const [isUtmLoaded, setUtmLoaded] = useState(false);

  useEffect(() => {
    setSessionStorage(
      SESSION_STORAGE.INITIAL_SESSION_URL,
      window.location.href
    );

    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.forEach((value, key) => {
      if (UTM_PARAMS_TO_BE_SAVED_IN_SESSION_STORAGE.includes(key)) {
        setSessionStorage(key, value);
      }
    });

    setUtmLoaded(true);
  }, []);

  return (
    <UtmContext.Provider value={{ isUtmLoaded }}>
      {children}
    </UtmContext.Provider>
  );
};

export const useUtm = () => useContext(UtmContext);

UtmProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UtmProvider;
